<template>
  <div class="skill-container app-container">
    <el-row :gutter="20">
      <el-col 
        v-for="skill in list" 
        :key="skill.Id" 
        :xs="24" 
        :sm="12" 
        :md="8" 
        :lg="6"
        class="skill-item"
      >
        <el-card shadow="hover">
          <div slot="header" class="skill-header">
            <h3>{{ skill.Name }}</h3>
            <div>
              <el-tag type="success" effect="dark">
                {{ skill.Price }}金币
              </el-tag>
              <el-tag :type="skill.Type === 'Permanent' ? 'warning' : 'info'" style="margin-left: 5px;">
                {{ skill.Type === 'Permanent' ? '永久' : '消耗品' }}
              </el-tag>
            </div>
          </div>
          <div class="skill-content">
            <p class="description">{{ skill.Description }}</p>
            <div class="meta-info">
              <el-tag v-if="skill.Type !== 'Permanent'" type="info">使用次数: {{ skill.UsageLimit }}</el-tag>
              <el-tag type="info">适用模式: {{ formatGameTypeNames(skill.ApplicableGameTypes) }}</el-tag>
              <el-tag v-if="skill.RequiredPermissionLevel > 0" :type="getPermissionType(skill.RequiredPermissionLevel)">
                {{ getPermissionText(skill.RequiredPermissionLevel) }}
              </el-tag>
            </div>
          </div>
          <div class="skill-footer">
            <el-button 
              type="primary" 
              @click="handlePurchase(skill.Id)"
              :loading="loadingMap[skill.Id]"
            >
              <i class="el-icon-shopping-cart"></i> 立即购买
            </el-button>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-pagination
      layout="total, prev, pager, next"
      :current-page="page"
      :page-size="20"
      :total="total"
      @current-change="handlePageChange"
    />
  </div>
</template>

<script>
import { getSkills, purchaseSkill, getGameTypes } from '@/api/api'

export default {
  data() {
    return {
      list: [],
      total: 0,
      page: 1,
      loadingMap: {},
      gameTypeList: [],
      dataLoading: true
    }
  },
  methods: {
    handleQuery() {
      this.dataLoading = true
      getSkills({
        page: this.page,
        pageSize: 20
      }).then(res => {
        if (res.data.success) {
          const response = res.data.response
          this.list = response.data
          this.total = response.dataCount
        }
      }).finally(() => {
        this.dataLoading = false
      })
    },

    fetchMetaData() {
      getGameTypes().then(gameTypes => {
        this.gameTypeList = gameTypes.data.response
      })
    },

    async handlePurchase(skillId) {
      this.$set(this.loadingMap, skillId, true)
      try {
        const res = await purchaseSkill(skillId)
        if (res.data.success) {
          this.$message.success(res.data.msg || '购买成功')
          this.handleQuery()
        } else {
          this.handlePurchaseError(res)
        }
      } catch (error) {
        this.handlePurchaseError(error.response)
      } finally {
        this.$set(this.loadingMap, skillId, false)
      }
    },

    handlePurchaseError(res) {
      if (res && res.data && res.data.msg && res.data.msg.includes('未绑定游戏角色')) {
        this.$confirm('需要先绑定游戏角色，是否前往绑定？', '提示', {
          confirmButtonText: '去绑定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push('/usercenter/profile')
        })
      } else {
        this.$message.error((res && res.data && res.data.msg) || '购买失败')
      }
    },

    formatGameTypeNames(gameTypes) {
      if (!gameTypes || this.dataLoading) return '加载中...'
      return gameTypes.split(',').map(name => {
        const type = this.gameTypeList.find(t => t.Name === name.trim())
        return type ? type.Description : name
      }).join('、')
    },

    handlePageChange(val) {
      this.page = val
      this.handleQuery()
    },

    getPermissionType(level) {
      const types = ['', 'success', 'warning', 'danger']
      return types[level] || 'info'
    },

    getPermissionText(level) {
      const texts = ['无限制', '总督权限', '提督权限', '舰长权限']
      return texts[level] || '未知权限'
    }
  },
  mounted() {
    this.handleQuery()
    this.fetchMetaData()
  }
}
</script>

<style scoped>
.skill-container {
  padding: 20px;
}

.skill-item {
  margin-bottom: 20px;
}

.skill-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.skill-header h3 {
  margin: 0;
  font-size: 16px;
}

.skill-content {
  min-height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.description {
  color: #666;
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 10px;
}

.meta-info {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.meta-info .el-tag {
  max-width: 100%;
  white-space: normal;
  word-break: break-all;
  height: auto;
  min-height: 28px;
  line-height: 1.4;
  padding: 4px 8px;
  margin: 2px 0;
  align-items: center;
}

.el-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.el-card__body {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.skill-footer {
  margin-top: 15px;
  text-align: center;
}
</style>
